"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RpcProvider = void 0;
var _providers = require("@ethersproject/providers");
var _bytes = require("@ethersproject/bytes");
class RpcProvider extends _providers.StaticJsonRpcProvider {
  static async estimateGas(provider, gasLimit, transaction) {
    let net = await provider.getNetwork();
    let data = await transaction.data;
    if (gasLimit) {
      if (data) {
        if (net.chainId === 1) {
          gasLimit = gasLimit.add(22000);
        } else {
          gasLimit = gasLimit.add(80000);
        }
        let signature = (0, _bytes.hexValue)(data).slice(0, 10);

        // Add to gas limit for Lotto play functions, since they can have a highly variable
        // gas cost. "play()" and "multiPlay(uint256)"
        if (signature === "0x93e84cd9" || signature === "0x5be319ee") {
          gasLimit = gasLimit.add(150000);
        }
      }
    }
    return gasLimit;
  }
  async estimateGas(transaction) {
    return RpcProvider.estimateGas(this, await super.estimateGas(transaction), transaction);
  }
}
exports.RpcProvider = RpcProvider;
//# sourceMappingURL=RpcProvider.js.map